module.exports = function (data) {
    return {
        event: 'BWSAUexistingCustomer',
        eventContext: {
            area: data.area,
            formName: data.formName,
            error: data.error,
            shopperId: data.shopperId
         }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/atmmapper/competition-disallow.js
 **/